// extracted by mini-css-extract-plugin
export default {"option":"RatingStars_option__5g-6t"};